import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBoxIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    fill="none"
    viewBox="0 0 17 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M1.246 11.756V4.202c0-.175.113-.334.287-.405l6.771-2.759a.52.52 0 0 1 .393 0l6.77 2.76c.175.07.288.23.288.404v7.554a.44.44 0 0 1-.287.405L8.697 14.92a.52.52 0 0 1-.393 0l-6.77-2.76a.44.44 0 0 1-.288-.404"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="m4.875 2.438 6.967 2.839c.175.07.287.23.287.405V8.35"
    />
  </svg>
);
export default SvgBoxIcon;
